import classNames from 'classnames'
import React, { useEffect } from 'react'
import { PiKeyReturnFill } from 'react-icons/pi'

import Card from '../Card/Card.tsx'

export type AccordionChildren = {
  squeezed: boolean
  setSqueezed: React.Dispatch<React.SetStateAction<boolean>>
  label?: string
  newLabel?: string
  setLabel: React.Dispatch<React.SetStateAction<string | undefined>>
  toggleSqueeze: () => void
}

type AccordionProps = {
  title?: string
  onSqueezeChange?: (squeezed: boolean) => void
  children: (args: AccordionChildren) => React.ReactNode
}

const Accordion = ({
  children,
  title = 'Accordion',
  onSqueezeChange
}: AccordionProps) => {
  const [squeezed, setSqueezed] = React.useState(false)
  const [label, setLabel] = React.useState<string | undefined>(undefined)

  useEffect(() => {
    if (!squeezed) setLabel(undefined)
    onSqueezeChange?.(squeezed)
  }, [squeezed, onSqueezeChange])

  const toggleSqueeze = () => {
    if (!squeezed) return
    setSqueezed((prev) => !prev)
  }

  return (
    <Card className="w-full">
      <Card.Body>
        <div
          onClick={toggleSqueeze}
          className={classNames('flex gap-2 items-center', {
            'cursor-pointer': squeezed
          })}
        >
          <p className="text-xl">{title}</p>
          {squeezed && (
            <div className="flex justify-center items-center">
              <PiKeyReturnFill size={36} className="text-green-600" />

            </div>
          )}
          {label && <p className="text-xl font-bold">{label}</p>}
        </div>

        {!squeezed &&
          children({
            squeezed,
            setSqueezed,
            label,
            newLabel: label,
            setLabel,
            toggleSqueeze
          })}
      </Card.Body>
    </Card>
  )
}

export default Accordion
